import _extends from "@babel/runtime/helpers/extends";
import styled from "@emotion/styled";
import { createContext } from "@smartsheet/lodestar-utils";
import React, { useMemo } from "react";
import { getTheme } from "./utils/getTheme";
import { getThemeClasses } from "./utils/getThemeClasses";
export const SDSThemeContext = createContext({}, "SDSThemeContext");
const StyledThemeProvider = styled.div`
    position: inherit;
    width: inherit;
    height: inherit;
    display: inherit;
    ${props => {
  return {
    ...props.innerWrapperStyles
  };
}}
`;
export const SDSThemeProvider = _ref => {
  let {
    children,
    innerWrapperStyles,
    themeKey,
    ...rest
  } = _ref;
  const theme = useMemo(() => {
    return getTheme(themeKey);
  }, [themeKey]);
  const themeClasses = useMemo(() => {
    return getThemeClasses(themeKey);
  }, [themeKey]);
  return /*#__PURE__*/React.createElement(SDSThemeContext.Provider, {
    value: theme
  }, /*#__PURE__*/React.createElement(StyledThemeProvider, _extends({
    innerWrapperStyles: innerWrapperStyles,
    className: themeClasses
  }, rest), children));
};
SDSThemeProvider.displayName = "SDSThemeProvider";
//# sourceMappingURL=SDSThemeProvider.js.map